import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import styles from "./JackpotHistoryDetailPop.module.scss";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import hex from "../../../assets/images/jackpotHex.png";
import hexglow from "../../../assets/images/jackpotglow.png";
import hexfade from "../../../assets/images/jackpotHexaFade.png";
import hexHalf from "../../../assets/images/jackpotHalfHex.png";
import { jackpotSlice } from "../../../lib/store/jackpot/slice";
import BtncIcn from "../../../assets/images/diamond.png";
import EnergyIcn from "../../../assets/images/current.png";
import USDTIcn from "../../../assets/images/usdt.png";

const JackpotHistoryDetailPop = ({ show, onHide }) => {
  const { jackpotDetail } = useSelector(({ Jackpot }) => Jackpot);
  const [jackpot, setJackpot] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(jackpotSlice.actions.setJackpotHistoryDetails({ data: null }));
      setTimeout(() => {
        setJackpot(null);
      }, 200);
    };
  }, [dispatch]);

  const decordData = async (jackpotDetails) => {
    try {
      setIsLoading(true);
      setJackpot(jackpotDetails);
    } catch (err) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (jackpotDetail?._id) {
      decordData(jackpotDetail);
    }
  }, [jackpotDetail]);

  const onCloseHandler = () => {
    onHide();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={() => onCloseHandler()}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.jackpotHistoryDetail} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={() => onCloseHandler()}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            {isLoading && (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner className={`${styles.mSpinner}`} size="sm" />
              </div>
            )}
            {jackpot && (
              <div
                className="mx-auto pt-4 allow-scroll"
                style={{
                  maxWidth: 292,
                  maxHeight: "cal(100vh - 230px)",
                  overflowY: "auto",
                }}
              >
                <div
                  className={`${styles.topWrpper} top p-2 px-3 mb-1`}
                  // style={{ background: "#0C0C0C" }}
                >
                  <div className="d-flex align-items-center gap-10">
                    <div
                      className="p-1 px-2 rounded text-white fw-sbold"
                      style={{ background: "#0E0E11" }}
                    >
                      ID:{jackpot?.jackpotID}
                    </div>
                    <div
                      className="p-1 rounded d-flex align-items-center gap-10 themeClr"
                      style={{ background: "#0E0E11" }}
                    >
                      <span>
                        {" "}
                        {jackpot?.completedAt &&
                          moment(jackpot?.completedAt).format("DD.MM.YY")}
                      </span>{" "}
                      <span className="">
                        {jackpot?.completedAt &&
                          moment(jackpot?.completedAt).format("HH:mm:ss")}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-between gap-10">
                      <li className="">
                        <p className="m-0 text-white">Claim</p>
                        <div className="d-flex align-items-center gap-10 flex-wrap">
                          {[
                            jackpot.wonJackpot
                              ? {
                                  icon: USDTIcn,
                                  amount: `$${jackpot.wonAmount || 0}`,
                                  label: "Jackpot",
                                }
                              : null,
                            jackpot.wonBtnc > 0
                              ? {
                                  icon: BtncIcn,
                                  amount: jackpot.wonBtnc,
                                  label: "BNTC",
                                }
                              : null,
                            jackpot.wonEnergy > 0
                              ? {
                                  icon: EnergyIcn,
                                  amount: jackpot.wonEnergy,
                                  label: "Energy",
                                }
                              : null,
                          ].filter(Boolean).length
                            ? (() => {
                                const winningsArr = [
                                  jackpot.wonJackpot
                                    ? {
                                        icon: USDTIcn,
                                        amount: `$${jackpot.wonAmount || 0}`,
                                        label: "Jackpot",
                                      }
                                    : null,
                                  jackpot.wonBtnc > 0
                                    ? {
                                        icon: BtncIcn,
                                        amount: jackpot.wonBtnc,
                                        label: "BNTC",
                                      }
                                    : null,
                                  jackpot.wonEnergy > 0
                                    ? {
                                        icon: EnergyIcn,
                                        amount: jackpot.wonEnergy,
                                        label: "Energy",
                                      }
                                    : null,
                                ].filter(Boolean);

                                if (winningsArr.length === 1) {
                                  const win = winningsArr[0];
                                  return (
                                    <div className="d-flex align-items-center text-white">
                                      <span className="icn me-1">
                                        <img
                                          src={win.icon}
                                          alt={win.label}
                                          style={{ height: 14, width: 14 }}
                                          className="img-fluid object-fit-contain"
                                        />
                                      </span>
                                      {win.amount}
                                    </div>
                                  );
                                } else {
                                  return (
                                    <>
                                      {winningsArr?.length
                                        ? winningsArr?.map((win, key) => (
                                            <div
                                              key={key}
                                              className="p-1 rounded text-white px-2"
                                              style={{ background: "#0E0E11" }}
                                            >
                                              <img
                                                src={win?.icon}
                                                style={{ height: 14 }}
                                                alt=""
                                                className="img-fluid object-fit-contain flex-shrink-0 me-1"
                                              />
                                              <span className="themeClr fw-sbold">
                                                {win?.amount}
                                              </span>
                                            </div>
                                          ))
                                        : null}
                                    </>
                                  );
                                }
                              })()
                            : "--"}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="bottom mt-2">
                  <h6 className="m-0 text-white ps-3">Result:</h6>
                  <div
                    className={`${styles.historyList} historyList mt-1`}
                    // style={{ background: "#19B0EB" }}
                  >
                    <div className="d-flex align-items-center gap-10">
                      <ul
                        className={`${styles.hexRow} text-center list-unstyled ps-0 mb-0 overflow-auto`}
                        //   style={{ height: "calc(100vh - 274px)" }}
                      >
                        <li
                          className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                          style={{
                            marginTop: "-23%",
                            opacity: 0.3,
                            gap: 10,
                          }}
                        >
                          <div className="">
                            <img
                              src={hexHalf}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div className="">
                            <img
                              style={{ transform: "scaleX(-1)" }}
                              src={hexHalf}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                        </li>

                        {jackpot?.potData?.map((row, rowIndex) => (
                          <li
                            key={rowIndex}
                            className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                          >
                            {/* Left half hex */}
                            <div>
                              <img
                                src={hexHalf}
                                alt=""
                                className="img-fluid object-fit-contain"
                              />
                            </div>

                            {/* Map inner array */}
                            {row.map((item, itemIndex) => (
                              <div
                                key={itemIndex}
                                className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                              >
                                {item.isOpened ? (
                                  <>
                                    <img
                                      src={hex}
                                      alt=""
                                      className="img-fluid object-fit-contain"
                                    />
                                    <img
                                      src={hexglow}
                                      alt=""
                                      className={`${styles.glow} mx-auto img-fluid object-fit-contain position-absolute`}
                                    />
                                  </>
                                ) : (
                                  <img
                                    src={hex}
                                    alt=""
                                    className="img-fluid object-fit-contain"
                                    style={{ opacity: 0.5 }}
                                  />
                                )}
                                <div
                                  className={`${styles.content} content position-absolute mx-auto`}
                                >
                                  {item.type !== "bomb" &&
                                    item.type !== "btnc" &&
                                    item.type !== "energy" && (
                                      <h6
                                        className="m-0 pb-1 fw-bold text-white"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {item?.type?.toUpperCase()}
                                      </h6>
                                    )}
                                  {(item.type === "btnc" ||
                                    item.type === "energy") && (
                                    <h6
                                      className="m-0 pb-1 fw-bold text-white"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {item?.value}
                                    </h6>
                                  )}
                                  <img
                                    src={item?.icon}
                                    alt={item?.type}
                                    className="img-fluid object-fit-contain"
                                  />
                                </div>
                              </div>
                            ))}

                            {/* Right half hex (mirrored) */}
                            <div>
                              <img
                                src={hexHalf}
                                style={{ transform: "scaleX(-1)" }}
                                alt=""
                                className="img-fluid object-fit-contain"
                              />
                            </div>
                          </li>
                        ))}

                        <li
                          className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                          style={{
                            maxHeight: 120,
                            overflow: "hidden",
                            opacity: 0.3,
                            gap: 10,
                          }}
                        >
                          <div className="">
                            <img
                              src={hexHalf}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div
                            className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          >
                            <img
                              src={hexfade}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                          <div className="">
                            <img
                              style={{ transform: "scaleX(-1)" }}
                              src={hexHalf}
                              alt=""
                              className="img-fluid object-fit-contain"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default JackpotHistoryDetailPop;
